import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { FloatButton } from 'antd';
import Icon from '@ant-design/icons';
import { TfiLayers } from 'react-icons/tfi';

import './CustomFloatButton.scss';

interface HeartSvgProps {
  value: string;
}

const HeartSvg: React.FC<HeartSvgProps> = ({ value }) => <p style={{ marginLeft: '-0.1rem' }}>{value}</p>;

interface HeartIconProps extends HeartSvgProps {
  [key: string]: any; // For any additional props passed to Icon
}

const HeartIcon: React.FC<HeartIconProps> = (props) => <Icon component={() => HeartSvg(props)} {...props} />;

interface CustomFloatButtonProps {
  is3D: boolean;
  setIs3d: () => void;
}

const CustomFloatButton: React.FC<CustomFloatButtonProps> = ({ is3D, setIs3d }) => (
  <div className="custom-float-button">
    <FloatButton.Group
      trigger="hover"
      type="primary"
      style={{
        right: 40,
      }}
      icon={<PlusOutlined />}
    >
      <FloatButton style={{ color: 'white', backgroundColor: 'white' }} icon={<TfiLayers />} />
      <FloatButton
        style={{
          color: 'white',
          backgroundColor: 'white',
        }}
        icon={<HeartIcon value={is3D ? '2D' : '3D'} />}
        onClick={setIs3d}
      />
    </FloatButton.Group>
  </div>
);

export default CustomFloatButton;
